import React from 'react';
// import './Notice.css'; // Make sure you have the appropriate CSS file.

const data = [
  { id: 1, Date:"27/Aug/25",notice: 'Scholarship Notice', download: '/CollegeNotice/27.08.26.pdf' },
  { id: 1, Date:"27/JAN/25",notice: 'Assignment of responsibilities of Controller of Examinations', download: '/CollegeNotice/23.01.26.pdf' },
  { id: 3, Date:"28/JAN/26",notice: 'Annual Sports Day', download: '/CollegeNotice/28.01.26.pdf' },
  { id: 4, Date:"29/JAN/26",notice: 'Exam Form BBA/BCA/B.Tech/M.Tech & MBA', download: '/CollegeNotice/29.01.26.pdf' },



]


const Notices = () => {
  return (
    <div className="main-container-notice">
      <div className="container-notice1">
        <div
          data-aos="flip-up"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
        >
          <h1 style={{textAlign:"center", color:"#134080"}}>Notice</h1> <br />
          <div className="table-wrapper">
            <table className="fl-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Date</th>
                  <th>Notice</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.Date}</td>
                    <td>{item.notice}</td>
                    <td>
                      <a
                        href={item.download}
                        download={item.download}
                        className="primary-button"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notices;
      